import React from 'react'
import { Button } from 'semantic-ui-react'


const AnimatedButton = ({visible, invisible, className, onClick, size}) => <Button size={size} onClick={onClick || undefined} className={`greyAppButton ${className || undefined}`} animated>
    <Button.Content visible>{visible}</Button.Content>
    <Button.Content hidden style={{top: '40%'}}>{invisible}</Button.Content>
</Button>

export default AnimatedButton